export class Coverage {
  coverage_selected: boolean;
  sublimit_sum?: number;
  sublimit_percentage?: number;

  constructor(coverage_selected: boolean, sublimit_sum: number, sublimit_percentage: number) {
    this.coverage_selected = coverage_selected;
    this.sublimit_sum = sublimit_sum;
    this.sublimit_percentage = sublimit_percentage;
  }
}

export class PreexistingConditionsCoverage {
  yearly_net_premium: number;
  sum_insured_current_year: number;
  preexisting_conditions: boolean;

  constructor(yearly_net_premium: number, sum_insured_current_year: number, preexisting_conditions: boolean) {
    this.yearly_net_premium = yearly_net_premium;
    this.sum_insured_current_year = sum_insured_current_year;
    this.preexisting_conditions = preexisting_conditions;
  }
}

export class WorldwideProtectionCoverage {
  yearly_net_premium: number;
  sum_insured: number;
  worldwide_protection: boolean;

  constructor(yearly_net_premium: number, sum_insured: number, worldwide_protection: boolean) {
    this.yearly_net_premium = yearly_net_premium;
    this.sum_insured = sum_insured;
    this.worldwide_protection = worldwide_protection;
  }
}
